import { render, staticRenderFns } from "./ConfigLocationList.vue?vue&type=template&id=6b7cca5d&scoped=true"
import script from "./ConfigLocationList.vue?vue&type=script&lang=js"
export * from "./ConfigLocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cca5d",
  null
  
)

export default component.exports